<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    media: String
  })

  const renderedMedia = computed(() => {
    const media = JSON.parse(props.media)
    if (!media) return false

    return {
      'element': media['element'],
      'videoUrl': media.props['video-file'],
      'thumbnailUrl': media.props['thumbnail-url']
    }
  })
</script>

<template>
  <section
    class="element-video ~mt-20/28 max-w-screen-2xl mx-auto px-6"
  >
    <GridLayout>
      <div class="lg:col-start-5 lg:col-span-8">
        <Media
          :media="renderedMedia"
        />
      </div>
    </GridLayout>
  </section>
</template>

<style lang="scss" scoped>

</style>
